import woltInstance from '../instance'

const markOrderReady = (orderId) => {
	return woltInstance.put(`/orders/${orderId}/ready`)
}

export default markOrderReady
